/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_ContactInputs */

const en_resume_contact = /** @type {(inputs: Resume_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const ar_resume_contact = /** @type {(inputs: Resume_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل`)
};

const bn_resume_contact = /** @type {(inputs: Resume_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`যোগাযোগ`)
};

const de_resume_contact = /** @type {(inputs: Resume_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const es_resume_contact = /** @type {(inputs: Resume_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacto`)
};

const fr_resume_contact = /** @type {(inputs: Resume_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const pt_resume_contact = /** @type {(inputs: Resume_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contato`)
};

const zh_resume_contact = /** @type {(inputs: Resume_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系方式`)
};

const tr_resume_contact = /** @type {(inputs: Resume_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İletişim`)
};

const ru_resume_contact = /** @type {(inputs: Resume_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контакт`)
};

const pl_resume_contact = /** @type {(inputs: Resume_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Resume_ContactInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_contact = /** @type {((inputs?: Resume_ContactInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_ContactInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_contact(inputs)
	if (locale === "bn") return bn_resume_contact(inputs)
	if (locale === "de") return de_resume_contact(inputs)
	if (locale === "es") return es_resume_contact(inputs)
	if (locale === "fr") return fr_resume_contact(inputs)
	if (locale === "pt") return pt_resume_contact(inputs)
	if (locale === "zh") return zh_resume_contact(inputs)
	if (locale === "tr") return tr_resume_contact(inputs)
	if (locale === "ru") return ru_resume_contact(inputs)
	if (locale === "pl") return pl_resume_contact(inputs)
	return en_resume_contact(inputs)
});